import React from 'react';
import PropTypes from 'prop-types';
import './ButtonPrimary.css';

const ButtonPrimary = ({ type, value, className, fontSize, padding, height, onClick}) => {
    return (
        <button
            type={type}
            className={`btn btn-primary btn-block tkmr-btn ${className}`}
            style={{
                fontSize: fontSize,       // Control font size via prop
                padding: padding,         // Control padding via prop
                height: height            // Control height via prop
            }}
            onClick={onClick}
        >
            {value}
        </button>
    );
};

ButtonPrimary.propTypes = {
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    className: PropTypes.string,
    fontSize: PropTypes.string,  // Optional fontSize prop
    padding: PropTypes.string,   // Optional padding prop
    height: PropTypes.string,     // Optional height prop
    onClick: PropTypes.func // Ensure onClick is a function
};

ButtonPrimary.defaultProps = {
    className: '',
    fontSize: '16px',   // Default font size
    padding: '0 15px',  // Default padding
    height: '45px'      // Default height
};

export default ButtonPrimary;
